import React, { Fragment } from 'react';
import { translate } from '../../../Services/translation';
import Slider from "react-slick";

const handleDragStart = (e) => e.preventDefault();

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className='newsBlock__carousel-next' onClick={onClick}>
            <span></span>
        </div>
    );
}
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className='newsBlock__carousel-prev' onClick={onClick}>
            <span></span>
        </div>
    );
}

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 5000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1.25,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
};


const NewsBlock = (props) => {
    const block = props.result.find(x => x.blockId === props.blockId);
    const getNewsArticle = (news) => {
        const result = [];
        news.sort((a, b) => new Date(b.newsDate) - new Date(a.newsDate));
        news.forEach(x => {
            if (x.imageViewModel && x.linkUrl !== window.location.pathname) {
                const date = new Date(x.newsDate);
                const formattedDate = date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
                result.push(
                    <a key={x.linkUrl} href={x.linkUrl} className='newsBlock__carousel-item'>
                        <div className='newsBlock__carousel-item--image'>
                            <img src={x.imageViewModel.url} alt={x.imageViewModel.alt} onDragStart={handleDragStart} role="presentation" />
                            {x.tag &&
                                <div className='newsBlock__carousel-item--image-tag'>
                                    <p>{x.tag}</p>
                                </div>
                            }
                        </div>
                        <div className='newsBlock__carousel-item--textContainer'>
                            {x.bodyTitle && <h4 className='newsBlock__carousel-item--title'>{x.bodyTitle}</h4>}
                            {x.bodySubTitle && <p className='newsBlock__carousel-item--subtitle' dangerouslySetInnerHTML={{ __html: x.bodySubTitle }}></p>}
                        </div>
                        {formattedDate && formattedDate !== "1-01-01" && <div className='newsBlock__carousel-item--date'>
                            <span></span>
                            <p>{formattedDate}</p>
                        </div>}
                    </a>
                )
            }
        })
        return result;
    }

    return (
        block && block.items?.length > 0 ?
            <div className='grid-system grid-system-within-boundaries'>
                <div className='grid-full-width'>
                    <div className='newsBlock'>
                        <div className='newsBlock__header'>
                            <h3 className='newsBlock__header--title'>{block.title}</h3>
                            <a className='newsBlock__header--seeAll' href={block.linkUrl}>{translate("articles-show-all")}</a>
                        </div>
                        <div className='newsBlock__carousel'>
                            <Slider
                                {...settings}
                            >
                                {getNewsArticle(block.items)}
                            </Slider>
                        </div>
                        <div className='newsBlock__viewAll'>
                            <a href={block.linkUrl}>{translate("articles-show-all")}</a>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Fragment></Fragment>
    )
}
export default NewsBlock;